export default __webpack_public_path__ + "static/media/risk-fofac-vh.fcb7ade6.png";